import { forwardRef } from "react";
import {
  BottomLeft,
  BottomRight,
  Container,
  ContainerToPrint,
  TopLeft,
  TopRight,
  HorizontalDivider,
  VerticalDividerTop,
  VerticalDividerBottom,
} from "./styles";

const ComponentToPrint = forwardRef((props, ref) => {
  return (
    <Container>
      <ContainerToPrint ref={ref}>
        <TopLeft>{props.children}</TopLeft>
        <VerticalDividerTop />
        <TopRight>{props.children}</TopRight>
        <HorizontalDivider />
        <BottomLeft>{props.children}</BottomLeft>
        <VerticalDividerBottom />
        <BottomRight>{props.children}</BottomRight>
      </ContainerToPrint>
      ;
    </Container>
  );
});

export default ComponentToPrint;
